
import type { BlockRendererProps } from '@/lib/email-builder/block-registry';
import { parseBlockConfiguration } from '@/types/email-blocks';
import type { DividerBlockConfiguration } from '@/types/block-configurations';

export function DividerBlock({ block, isSelected, isHovered, onSelect, onHover }: BlockRendererProps) {
  const config = parseBlockConfiguration(block) as DividerBlockConfiguration;

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        onSelect(block.id);
      }}
      onMouseEnter={(e) => {
        e.stopPropagation();
        onHover(block.id);
      }}
      onMouseLeave={() => onHover(null)}
      className={`
        lw-block-divider cursor-pointer rounded transition-all
        ${isSelected ? 'ring-2 ring-primary ring-offset-2' : ''}
        ${isHovered && !isSelected ? 'ring-1 ring-muted-foreground/50' : ''}
      `}
      style={{
        paddingTop: `${config.padding?.top || 0}px`,
        paddingRight: `${config.padding?.right || 0}px`,
        paddingBottom: `${config.padding?.bottom || 0}px`,
        paddingLeft: `${config.padding?.left || 0}px`,
      }}
    >
      <hr
        style={{
          border: 'none',
          borderTop: `${config.border?.width ?? 1}px ${config.border?.style || 'solid'} ${config.border?.color || '#cccccc'}`,
          width: config.width || '100%',
          marginTop: 0,
          marginBottom: 0,
          marginLeft: config.alignment?.horizontal === 'left' ? 0 : 'auto',
          marginRight: config.alignment?.horizontal === 'right' ? 0 : 'auto',
        }}
      />
    </div>
  );
}
